export default __webpack_public_path__ + "static/media/2.3d1a4b5a.jpg";